/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import { gql } from 'urql';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type GiftCardOrderDetailQueryVariables = Exact<{
  orderId: string;
}>;

export type GiftCardOrderDetailQuery = {
  readonly giftCardOrderDetail:
    | {
        readonly __typename: 'GiftCardOrderDetail';
        readonly id: string;
        readonly deliveryDetail: { readonly deliveryDateTime: string | null };
        readonly userGiftCards: ReadonlyArray<{
          readonly __typename: 'UserGiftCard';
          readonly id: string;
          readonly redemptionToken: string | null;
          readonly balance: number;
          readonly assetId: string | null;
          readonly recipientEmail: string | null;
          readonly recipientName: string;
          readonly message: string | null;
        }>;
      }
    | { readonly __typename: 'GiftCardOrderNotFoundError'; readonly errorMessage: string };
};

export const GiftCardOrderDetailDocument = gql`
  query GiftCardOrderDetail($orderId: String!) {
    giftCardOrderDetail(orderId: $orderId) {
      __typename
      ... on GiftCardOrderNotFoundError {
        errorMessage
      }
      ... on GiftCardOrderDetail {
        id
        deliveryDetail {
          deliveryDateTime
        }
        userGiftCards {
          id
          __typename
          redemptionToken
          balance
          assetId
          recipientEmail
          recipientName
          message
        }
      }
    }
  }
`;

export function useGiftCardOrderDetailQuery(
  options: Omit<Urql.UseQueryArgs<GiftCardOrderDetailQueryVariables>, 'query'>,
) {
  return Urql.useQuery<GiftCardOrderDetailQuery, GiftCardOrderDetailQueryVariables>({
    query: GiftCardOrderDetailDocument,
    ...options,
  });
}
